import React, { useState } from 'react'

const Contacto = () => {
  const [enviado, setEnviado] = useState(false)

  const manejarSubmit = async (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    const datos = Object.fromEntries(formData.entries())

    try {
      // Enviar a un Worker de Cloudflare (endpoint simulado)
      const respuesta = await fetch('https://ejemplo.pages.dev/api/contacto', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(datos)
      })

      if (respuesta.ok) {
        setEnviado(true)
        // Resetear formulario después de 3 segundos
        setTimeout(() => setEnviado(false), 3000)
      } else {
        alert('Error al enviar el formulario')
      }
    } catch (error) {
      console.error('Error:', error)
      alert('Error de conexión. Por favor, inténtalo de nuevo.')
    }
  }

  return (
    <section className="section">
      <h2>Contacto</h2>
      {enviado ? (
        <p style={{ textAlign: 'center', marginTop: '2rem' }}>¡Gracias! Hemos recibido tu mensaje. Te contactaremos pronto.</p>
      ) : (
        <form onSubmit={manejarSubmit} noValidate>
          <div className="form-group">
            <label>Nombre completo</label>
            <input type="text" name="nombre" required />
          </div>
          <div className="form-group">
            <label>Correo electrónico</label>
            <input type="email" name="email" required />
          </div>
          <div className="form-group">
            <label>Empresa o proyecto</label>
            <input type="text" name="empresa" />
          </div>
          <div className="form-group">
            <label>Mensaje</label>
            <textarea name="mensaje" rows="4" required />
          </div>
          <button type="submit">Enviar mensaje</button>
        </form>
      )}
    </section>
  )
}

export default Contacto